exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-03b1fabc]{border-bottom:0}", ""]);

// exports
